import { Component, Input, OnInit } from '@angular/core';
import { DeviceModel } from '@bo-client/activation-management/shared/models/deviceModel';

@Component({
  selector: 'app-gas-devices-summary',
  templateUrl: './gas-devices-summary.component.html',
  styleUrls: ['../../../../../../../shared/summaries/css-summary.component.scss']
})
export class GasDevicesSummaryComponent implements OnInit {
  @Input() devices: DeviceModel[] = [];
  public totalPower = 0;
  public totalLoad = 0;

  constructor() {}

  ngOnInit(): void {
    this.totalPower = 0;
    this.devices
      .filter((device) => device.state !== 'demontiert') // Demontierte Verbraucher werden nicht berücksichtigt
      .forEach((device) => {
        this.totalPower = +this.totalPower + +device.power;
        this.totalLoad = +this.totalLoad + +device.load;
      });
  }
}
